export default "__VITE_ASSET___$KEgXE4__"